<template>
  <div class="card">
    <div class="card-header text-right">
      <div class="w-100 d-flex justify-content-end">
        <h3 class="m-0">{{ $t('phrase.questions_in_research') }}</h3>
      </div>
    </div>
    <div class="card card-body bg-light overflow-auto">
      <div v-if="researchItems.length > 0">
        <div
          v-for="(researchItem, index) in researchItems"
          :key="researchItem.id"
          :class="index !== researchItems.length - 1 ? 'mb-2' : ''"
        >
          <v-research-item
            :research-item="researchItem"
            :edit-mode="false"
            :index="index + 1"
            :is-locked="researchItem.is_locked"
          />
        </div>
      </div>
      <div v-else class="text-center text-muted">
        {{ $t('sentence.no_questions_in_research') }}
      </div>
    </div>
  </div>
</template>

<script>
import ResearchItem from '@/organisation/components/research/ResearchItem.vue';

export default {
  name: 'ResearchStructureView',
  components: {
    'v-research-item': ResearchItem,
  },
  data() {
    return {
      addedResearchItems: [],
      lockedResearchItems: [],
    };
  },
  props: {
    research: {
      type: Object,
      required: true,
    },
    researchItems: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.addedResearchItems = this.researchItems
      .filter((item) => item.is_locked === false);
    this.lockedResearchItems = this.researchItems
      .filter((item) => item.is_locked === true);
  },
};
</script>
